import { ILanguage } from "../../../core/model/language/Language";
import { IIndexType } from "../../../indexTypes/model/IndexType";
import { IOrganisation } from "../../model/Organisation";
import { IOrganisationIndex } from "../../model/OrganisationIndex";
import OrganisationIndexGroupPresentationModel, {
  TOrganisationIndexGroupPresentationModel
} from "./OrganisationIndexGroupPresentationModel";

export interface TOrganisationIndexPresentationModel
  extends IOrganisationIndex {
  id: number;
  name: string;
  organisation: IOrganisation;
  indexType?: IIndexType;
  pathToIndex: string[];
  nameTranslation: string;
  groups: TOrganisationIndexGroupPresentationModel[];
}

const OrganisationIndexPresentationModel = (
  data: IOrganisationIndex,
  organisation?: IOrganisation,
  indexType?: IIndexType,
  connected?: boolean,
  pathToIndex?: string[],
  selectedLanguage?: ILanguage
) => {
  const nameTranslation = data.nameTranslations.find(
    (item) => item.languageId === selectedLanguage?.id
  )?.nameTranslation;
  const handler: ProxyHandler<IOrganisationIndex> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "id":
          return data?.id;
        case "name":
          return data.name;
        case "organisation":
          return organisation;
        case "indexType":
          return indexType;

        case "pathToIndex":
          return pathToIndex;
        case "nameTranslation":
          return nameTranslation;
        case "groups":
          return data?.groups?.map((item) =>
            OrganisationIndexGroupPresentationModel(item, selectedLanguage)
          );
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "groups":
          return true;
        case "id":
        case "name":
        case "organisation":
        case "indexType":
        case "pathToIndex":
        case "connected":

        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IOrganisationIndex, TOrganisationIndexPresentationModel>(
    data,
    handler
  );
};

export default OrganisationIndexPresentationModel;
